/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { Boundary } from '@floating-ui/react';
import classNames from 'classnames';

import SettingsFillSvg from 'bundles/video-player/assets/svg/SettingsFillSvg';
import SettingsSvg from 'bundles/video-player/assets/svg/SettingsSvg';
import ModernTooltipWrapper from 'bundles/video-player/components/ModernTooltipWrapper';

import _t from 'i18n!nls/video-player';

type Props = {
  menuPopupVisible: boolean;
  videoBoundaryElement?: Boundary;
  onClick: () => void;
};

const SettingsMenuButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ menuPopupVisible, videoBoundaryElement, onClick }, ref) => {
    const label = _t('Settings');

    const settingsButtonOnClick = () => {
      // TODO: when migrating to eventing v3, add settings_menu_open and settings_menu_close click events.
      // We removed the eventing v3 events for this because the namespace app name set in VideoPlayer.tsx correctly formatted and it is too expensive
      // to change that since it would require DS/DE to change every usage of open_course.video events as well
      onClick();
    };

    const modernSettingsMenuSvg = menuPopupVisible ? (
      <SettingsFillSvg width={28} height={28} />
    ) : (
      <SettingsSvg width={28} height={28} />
    );

    const button = (
      <button
        type="button"
        onClick={settingsButtonOnClick}
        className={classNames('vjs-menu-button', 'vjs-menu-button-popup', 'vjs-button', 'vjs-control', 'c-vjs-button')}
        aria-disabled="false"
        aria-haspopup="true"
        aria-expanded={menuPopupVisible}
        ref={ref}
      >
        {modernSettingsMenuSvg}
        <span className="vjs-control-text"> {label} </span>
      </button>
    );

    return (
      <ModernTooltipWrapper placement="top" message={label} videoBoundaryElement={videoBoundaryElement} offset={10}>
        {button}
      </ModernTooltipWrapper>
    );
  }
);

export default SettingsMenuButton;
